module.exports = __webpack_public_path__ + "static/media/download.fad8a4e9.svg";